import { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { BRAND } from '../../data/constants.js';

const NAV = [
  ['Venta',           '/buscar?op=venta'],
  ['Alquiler',        '/buscar?op=alquiler'],
  ['Emprendimientos', '/buscar?op=venta&dev=1'],
  ['Tasación',        '/vender?modo=tasacion'],
  ['Nosotros',        '/nosotros'],
  ['Contacto',        '/contacto'],
];

export default function Header({ onOpenMenu, favs = [], cmp = [] }) {
  const [scrolled, setScrolled] = useState(false);
  const loc = useLocation();
  useEffect(() => {
    const h = () => setScrolled(window.scrollY > 20);
    h(); window.addEventListener('scroll', h, { passive: true });
    return () => window.removeEventListener('scroll', h);
  }, []);
  const active = href => loc.pathname + loc.search === href || loc.pathname === href.split('?')[0];

  return (
    <header className={"hdr" + (scrolled ? " scrolled" : "")}>
      <div className="topbar">
        <div className="topbar-in">
          <div className="tb-left">
            <a className="tb-item" href={"tel:" + BRAND.phoneVentas.replace(/[^0-9+]/g,'')}>📞 <span>Ventas {BRAND.phoneVentas}</span></a>
            <a className="tb-item" href={"tel:" + BRAND.phoneAlquileres.replace(/[^0-9+]/g,'')}>📞 <span>Alquileres {BRAND.phoneAlquileres}</span></a>
            <span className="tb-item tb-addr">📍 {BRAND.address}</span>
          </div>
          <div className="tb-right">
            <span className="tb-hours">🕐 {BRAND.hours}</span>
            <a className="tb-soc" href={BRAND.instagram} target="_blank" rel="noopener" aria-label="Instagram">IG</a>
            <a className="tb-soc" href={BRAND.facebook}  target="_blank" rel="noopener" aria-label="Facebook">FB</a>
          </div>
        </div>
      </div>
      <div className="hdr-in">
        <Link className="brand" to="/">
          <div className="brand-text">
            <span className="brand-mark">Abriola</span>
            <span className="brand-sub">Propiedades</span>
          </div>
        </Link>
        <nav className="hdr-nav" aria-label="Principal">
          {NAV.map(([t, h]) => (
            <Link key={t} to={h} className={active(h) ? 'on' : ''}>{t}</Link>
          ))}
        </nav>
        <div className="hdr-actions">
          <Link className="hdr-ic" to="/comparar" title="Comparador" aria-label="Comparador">
            ⇄{cmp.length > 0 && <span className="hdr-badge">{cmp.length}</span>}
          </Link>
          <Link className="hdr-ic" to="/favoritos" title="Favoritos" aria-label="Favoritos">
            ♥{favs.length > 0 && <span className="hdr-badge">{favs.length}</span>}
          </Link>
          <Link className="btn btn-dark btn-sm hdr-cta" to="/vender">Vender mi propiedad</Link>
          <button className="hdr-burger" onClick={onOpenMenu} aria-label="Abrir menú">☰</button>
        </div>
      </div>
    </header>
  );
}
